import { defineStore } from "pinia";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    count: 555,
    user: {},
    deviceInfo: {}
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        key: "counter",
        storage: localStorage
      }
    ]
  },
  actions: {
    increment() {
      this.count++;
    },
    decrement() {
      this.count--;
    }
  }
});

export const useDeviceStore = defineStore("device", {
  state: () => ({
    deviceInfo: {},
    isSupper: true
  }),
  actions: {
    getDeviceInfo() {
      let that = this;
      plus.device.getInfo({
        success: function(e) {
          console.log("getDeviceInfo success: " + JSON.stringify(e));
          that.deviceInfo = e;
        },
        fail: function(e) {
          console.log("getDeviceInfo failed: " + JSON.stringify(e));
        }
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js